import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import PriceVatDisclaimer from 'common/PriceVatDisclaimer';


const rows = [
  {
    item: 'Streaming 24/7',
    detail: '12 spots diarios (20 seg) en la señal de Radio Visual.',
  },
  {
    item: 'En Producción con MEM',
    detail: '3 menciones semanales, entrevistas con voceros de Daka y análisis de producto en vivo.',
  },
  {
    item: 'TNO Digest (SEO Premium)',
    detail:
      '4 artículos al mes por periodistas expertos en SEO (reseñas, comparativas y enlaces directos a tienda Daka).',
  },
  {
    item: 'Contenido UGC',
    detail:
      'Piezas para redes y señal con usuarios reales o voceros mostrando productos Daka en uso. Prueba social y mayor confianza para la audiencia.',
  },
  {
    item: 'Banner digital',
    detail: 'Presencia permanente en el portal informativo de TNO.',
  },
];

const PlanEvolucion = () => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
          gutterBottom
          color="primary"
          align="center"
        >
          Plan de inversión mensual
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant="h4"
          gutterBottom
          align="center"
          color="primary"
        >
          Evolución Daka
        </Box>
        <Typography
          variant="body1"
          color="textSecondary"
          align="center"
          sx={{ maxWidth: 640, mx: 'auto' }}
        >
          Oferta integral de alto impacto: una inversión mensual que integra streaming, programa ancla, Digest SEO y UGC.
        </Typography>
      </Box>
      <TableContainer
        component={Paper}
        elevation={2}
        sx={{ maxWidth: 800, mx: 'auto', borderRadius: 2 }}
      >
        <Table>
          <TableHead>
            <TableRow sx={{ bgcolor: theme.palette.primary.main }}>
              <TableCell sx={{ color: 'white', fontWeight: 700 }}>Concepto</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 700 }}>Inclusión</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, i) => (
              <TableRow key={i} hover>
                <TableCell>{row.item}</TableCell>
                <TableCell>{row.detail}</TableCell>
              </TableRow>
            ))}
            <TableRow sx={{ bgcolor: theme.palette.secondary.main }}>
              <TableCell sx={{ color: 'rgba(0,0,0,0.87)', fontWeight: 700 }}>Inversión mensual total</TableCell>
              <TableCell align="right" sx={{ color: 'rgba(0,0,0,0.87)', fontWeight: 700 }}>
                $800
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <PriceVatDisclaimer />
    </Box>
  );
};

export default PlanEvolucion;
